import React, { useState } from "react";
import axios from "axios"; // Ensure axios is installed
import { NotificationManager } from "react-notifications"; // Ensure notification library is installed
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Appconfig from "../../config/config";

const Skylivecasino = () => {
  const [launchingId, setLaunchingId] = useState(null);
  const [loadProgress, setLoadProgress] = useState(0);
  const [showClose, setShowClose] = useState(false);
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.userInfo?.userdata); // get login user details

  let casinoBlock = "No";
  casinoBlock = userInfo?.is_casino_bet_lock;

  const closeLoader = () => {
    setLaunchingId(null);
    setShowClose(false);
    setLoadProgress(0);
  };

  // ==========================================
  // 1. DATA: PLATFORM LIST (Original Data)
  // ==========================================
  const games = [
    {
      id: 1,
      title: "BETGAMES",
      provider_code: "QT", // Added
      game_code: "BTV-lobby", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/BETGAMES_cover.png",
      listImage: "/casinoimages/BETGAMES.png",
      btnType: "play",
      cornerIcon: "fa-volume-xmark",
    },
    {
      id: 2,
      title: "HORSEBOOK",
      provider_code: "SN", // Added
      game_code: "VCR", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/HORSEBOOK_cover.png",
      listImage: "/casinoimages/HORSEBOOK.png",
      btnType: "play",
      cornerIcon: "fa-volume-xmark",
    },
    {
      id: 3,
      title: "JDB",
      provider_code: "DC", // Added
      game_code: "900000", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/JDB_cover.png",
      listImage: "/casinoimages/JDB.png",
      btnType: "view",
      cornerIcon: "fa-gamepad",
    },
    {
      id: 4,
      title: "JILI",
      provider_code: "DC", // Added
      game_code: "600000", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/JILI_cover.png",
      listImage: "/casinoimages/JILI.png",
      btnType: "view",
      cornerIcon: "fa-star",
    },
    {
      id: 5,
      title: "KINGMIDAS",
      provider_code: "DC", // Added
      game_code: "400053", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/KINGMAKER_cover.png",
      listImage: "/casinoimages/KINGMAKER.png",
      btnType: "view",
      cornerIcon: "fa-crown",
    },
    {
      id: 6,
      title: "SEVENMOJOS",
      provider_code: "SN", // Added
      game_code: "VUD7", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SEVENMOJOS_cover.png",
      listImage: "/casinoimages/SEVENMOJOS.png",
      btnType: "view",
      cornerIcon: "fa-dice",
    },
    {
      id: 7,
      title: "SEXY",
      provider_code: "SN", // Added
      game_code: "VPK", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SEXYBCRT_cover.png",
      listImage: "/casinoimages/SEXYBCRT.png",
      btnType: "play",
      cornerIcon: "fa-heart",
    },
    {
      id: 8,
      title: "SKYCASINO",
      provider_code: "SN", // Added
      game_code: "VPK20", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SKYCASINO_cover.png",
      listImage: "/casinoimages/SKYCASINO.png",
      btnType: "play",
      cornerIcon: "fa-cloud",
    },
    {
      id: 9,
      title: "SMARTSOFT",
      provider_code: "SMTSG", // Added
      game_code: "", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SMARTSOFT_cover.png",
      listImage: "/casinoimages/SMARTSOFT.png",
      btnType: "view",
      cornerIcon: "fa-robot",
    },
    {
      id: 10,
      title: "SPADE",
      provider_code: "SN", // Added
      game_code: "V3TP", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SPADE_cover.png",
      listImage: "/casinoimages/SPADE.png",
      btnType: "view",
      cornerIcon: "fa-spade",
    },
    {
      id: 11,
      title: "SPORTRADAR",
      provider_code: "SN", // Added
      game_code: "RCQ20", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SPORTRADAR_cover.png",
      listImage: "/casinoimages/SPORTRADAR.png",
      btnType: "play",
      cornerIcon: "fa-futbol",
    },
    {
      id: 12,
      title: "SUPERNOWA",
      provider_code: "SN", // Added
      game_code: "", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SUPERNOWA_cover.png",
      listImage: "/casinoimages/SUPERNOWA.png",
      btnType: "play",
      cornerIcon: "fa-rocket",
    },
    {
      id: 13,
      title: "SV388",
      provider_code: "SN", // Added
      game_code: "MTP7M", // Added
      casino_type: "WCO", // Added
      gridImage: "/casinoimages/SV388_cover.png",
      listImage: "/casinoimages/SV388.png",
      btnType: "play",
      cornerIcon: "fa-rocket",
    },
  ];

  // ==========================================
  // 2. DATA: HOT GAMES
  // ==========================================
  const hotGames = [
    {
      id: 101,
      provider_code: "QT", // Added
      game_code: "KAG-dragontiger", // Added
      casino_type: "WCO", // Added
      title: "SV388",
      provider: "SV388",
      img: "/casinoimages/games/SV388.png",
      tags: ["HOT"],
    },
    {
      id: 102,
      provider_code: "EZ", // Added
      game_code: "228000", // Added
      casino_type: "WCO", // Added
      title: "Andar Bahar",
      provider: "KINGMIDAS",
      img: "/casinoimages/games/KM-TABLE-032.png",
      tags: ["HOT"],
    },
    {
      id: 103,
      provider_code: "DC", // Added
      game_code: "600051", // Added
      casino_type: "WCO", // Added
      title: "RomaX",
      provider: "JILI",
      img: "/casinoimages/games/JILI-SLOT-040.png",
      tags: ["HOT", "500X"],
    },
    {
      id: 104,
      provider_code: "DC", // Added
      game_code: "400056", // Added
      casino_type: "WCO", // Added
      title: "Sicbo",
      provider: "KINGMIDAS",
      img: "/casinoimages/games/KM-TABLE-015.png",
      tags: ["HOT", "2x BONUS"],
    },
    {
      id: 105,
      provider_code: "EZ", // Added
      game_code: "507000", // Added
      casino_type: "WCO", // Added
      title: "SEXY",
      provider: "SEXY",
      img: "/casinoimages/games/SEXYBCRT.png",
      tags: ["HOT"],
    },
    {
      id: 106,
      provider_code: "SN", // Added
      game_code: "VCR", // Added
      casino_type: "WCO", // Added
      title: "HORSEBOOK",
      provider: "HORSEBOOK",
      img: "/casinoimages/games/HORSEBOOK.png",
      tags: ["HOT"],
    },
  ];

  // Sub-categories for the "Games" Tab
  const gameCategories = [
    { name: "Hot", icon: "fa-fire" },
    { name: "Live", icon: "fa-video" },
    { name: "Fishing", icon: "fa-fish" },
    { name: "Slot", icon: "fa-gem" },
    { name: "Table", icon: "fa-table-cells" },
    { name: "Egame", icon: "fa-gamepad" },
    { name: "Sports", icon: "fa-futbol" },
  ];

  // ==========================================
  // 3. STATE MANAGEMENT
  // ==========================================
  const [activeTab, setActiveTab] = useState("Platform");
  const [gameSubTab, setGameSubTab] = useState("Hot");
  const [viewMode, setViewMode] = useState("list");
  const [showBalance, setShowBalance] = useState(false);
  {
    /* --- HELPER FUNCTION FOR COLORS & ICONS --- */
  }
  const getProviderAssets_old = (provider) => {
    switch (provider) {
      case "JILI":
        return {
          // Blue Gradient
          bg: "bg-gradient-to-r from-[#174894] to-[#0a234a]",
          // Slot Machine Icon
          icon: (
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-full h-full"
            >
              <path d="M17,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V5A3,3,0,0,0,17,2Zm1,17a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4H17a1,1,0,0,1,1,1Z" />
              <path d="M8,8h2v2H8Z" /> <path d="M14,8h2v2H14Z" />{" "}
              <path d="M11,13h2v2H11Z" />
            </svg>
          ),
        };
      case "KINGMIDAS":
        return {
          // Purple Gradient
          bg: "bg-gradient-to-r from-[#62166d] to-[#2c0833]",
          // Spade Card Icon
          icon: (
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-full h-full"
            >
              <path d="M16 2H8C5.79 2 4 3.79 4 6v12c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4zm-4 14c-2.48 0-4.5-1.57-4.5-3.5 0-1.66 1.34-3 3-3 .55 0 1 .45 1 1 .69-1.39 2.31-2.29 2.5-2.39.87-.46 2.02.16 2.02 1.15 0 2.07-1.79 6.74-4.02 6.74z" />
              <path d="M17 4h-2v2h2V4z" />
            </svg>
          ),
        };
      default: // SEXY, SV388, HORSEBOOK
        return {
          // Dark Red Gradient
          bg: "bg-gradient-to-r from-[#851e29] to-[#450912]",
          // Dealer/Person Icon
          icon: (
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-full h-full"
            >
              <path d="M16.5,5.5A2.5,2.5,0,1,0,14,3,2.5,2.5,0,0,0,16.5,5.5Zm-8,0A2.5,2.5,0,1,0,6,3,2.5,2.5,0,0,0,8.5,5.5Z" />
              <path d="M19.5,8H17V7a1,1,0,0,0-2,0V8H11V7a1,1,0,0,0-2,0V8H5.5A2.5,2.5,0,0,0,3,10.5V19a1,1,0,0,0,1,1H7V18a3,3,0,0,1,6,0v2h9a1,1,0,0,0,1-1V10.5A2.5,2.5,0,0,0,19.5,8Z" />
            </svg>
          ),
        };
    }
  };

  // ==========================================
  // LOGIC: Updated Launch Functions
  // ==========================================
  async function CreateAndLaunchWCOCasino(
    provider_code,
    game_code,
    type = null,
  ) {
    if (Appconfig.sitecodes !== "P56") {
      closeLoader();
      return;
    }

    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: window.location.hostname,
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    try {
      const config = {
        method: "post",
        url: `${Appconfig.apiUrl}wco/login`,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(userData),
      };

      const response = await axios(config);
      let status = response.data.status?.code;

      if (status === "SUCCESS") {
        window.open(response.data.launchURL, "_self");
      } else {
        // API responded but failed (e.g., Game Not Found)
        setShowClose(true);
        NotificationManager.error(
          response.data.status?.message || "Error",
          "",
          2000,
        );
      }
    } catch (error) {
      // Network or Server Error
      setShowClose(true);
      console.error(error);
      NotificationManager.error("Server Connection Failed", "", 2000);
    }
  }

  const handleGameClick = async (game) => {
    if (casinoBlock === "Yes") {
      NotificationManager.error("Casino Block By Upline", "", 3000);
      return;
    }

    setLaunchingId(game.id);
    setLoadProgress(0);
    setShowClose(false);

    const interval = setInterval(() => {
      setLoadProgress((prev) => (prev < 98 ? prev + 2 : prev));
    }, 60);

    if (game.casino_type === "WCO") {
      await CreateAndLaunchWCOCasino(
        game.provider_code,
        game.game_code,
        game.type,
      );
    } else {
      // Internal navigation logic
      setTimeout(() => {
        clearInterval(interval);
        navigate(`/casino/${game.id}`);
      }, 1500);
    }
  };

  const getProviderAssets = (provider) => {
    switch (provider) {
      case "JILI":
        return {
          bg: "bg-gradient-to-r from-[#174894] to-[#0a234a]",
          icon: <i className="fa-solid fa-gem text-xs"></i>,
        };
      case "KINGMIDAS":
        return {
          bg: "bg-gradient-to-r from-[#62166d] to-[#2c0833]",
          icon: <i className="fa-solid fa-crown text-xs"></i>,
        };
      default:
        return {
          bg: "bg-gradient-to-r from-[#851e29] to-[#450912]",
          icon: <i className="fa-solid fa-heart text-xs"></i>,
        };
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] font-sans text-white overflow-x-hidden">
      {/* INJECTED STYLES FOR ANIMATIONS 
          (Required because the provided HTML uses custom animation classes)
      */}

      {/* --- FULL SCREEN LOADER OVERLAY --- */}
      {/* --- FULL SCREEN LOADER OVERLAY --- */}
      {launchingId && (
        <>
          <style>{`
      @keyframes circlePulse {
        0% { transform: scale(1); opacity: 1; stroke-width: 6; }
        50% { transform: scale(1.05); opacity: 0.7; stroke-width: 8; }
        100% { transform: scale(1); opacity: 1; stroke-width: 6; }
      }
      .animate-circle-pulse {
        animation: circlePulse 1.5s infinite ease-in-out;
      }
    `}</style>

          <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/60 backdrop-blur-[3px] transition-all duration-500">
            {/* CROSS BUTTON (Shows only on failure) */}
            {showClose && (
              <button
                onClick={closeLoader}
                className="absolute top-10 right-10 w-12 h-12 flex items-center justify-center bg-red-600/20 hover:bg-red-600 rounded-full border border-red-500/50 text-white transition-all shadow-[0_0_15px_rgba(220,38,38,0.5)]"
              >
                <i className="fa-solid fa-xmark text-2xl"></i>
              </button>
            )}

            <div className="relative w-28 h-28 md:w-36 md:h-36">
              <svg className="w-full h-full transform -rotate-90">
                {/* Background Track */}
                <circle
                  cx="50%"
                  cy="50%"
                  r="45%"
                  stroke="rgba(255,255,255,0.05)"
                  strokeWidth="6"
                  fill="transparent"
                />
                {/* Progress Circle with Pulse logic */}
                <circle
                  cx="50%"
                  cy="50%"
                  r="45%"
                  stroke="#c49a50"
                  strokeWidth="6"
                  fill="transparent"
                  strokeDasharray="283"
                  strokeDashoffset={283 - (283 * loadProgress) / 100}
                  strokeLinecap="round"
                  className={`transition-all duration-300 ease-out 
              ${loadProgress >= 98 && !showClose ? "animate-circle-pulse" : ""}
              ${showClose ? "stroke-red-500" : ""}`}
                />
              </svg>

              {/* Percentage Display */}
              <div className="absolute inset-0 flex items-center justify-center">
                <span
                  className={`text-xl md:text-2xl font-bold tracking-tighter transition-colors ${showClose ? "text-red-500" : "text-white"}`}
                >
                  {showClose ? "!" : `${loadProgress}%`}
                </span>
              </div>
            </div>

            <div className="mt-8 flex flex-col items-center px-6">
              <h2
                className={`text-lg md:text-xl font-bold uppercase tracking-[0.2em] transition-all 
          ${showClose ? "text-red-500" : "text-[#fceeb5] animate-pulse"}`}
              >
                {showClose ? "Launch Failed" : "Opening......"}
              </h2>

              {showClose ? (
                <p className="text-gray-300 text-sm mt-2 text-center">
                  The casino server could not be reached. <br />
                  Click the <span className="text-red-500 font-bold">
                    X
                  </span>{" "}
                  button to return.
                </p>
              ) : (
                <p className="text-gray-400 text-xs mt-2 italic opacity-70">
                  Please wait while we secure your seat...
                </p>
              )}
            </div>
          </div>
        </>
      )}

      <style>{`
        @keyframes fadeInLeft {
          from { opacity: 0; transform: translateX(-20px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeInRight {
          from { opacity: 0; transform: translateX(20px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn-left { animation: fadeInLeft 0.8s forwards; }
        .animate-fadeIn-right { animation: fadeInRight 0.8s forwards; }
        .animate-fadeIn { animation: fadeIn 0.8s forwards; }
        .animate-delay-250 { animation-delay: 250ms; }
        .animate-delay-500 { animation-delay: 500ms; }
        .animate-delay-750 { animation-delay: 750ms; }
      `}</style>

      {/* -----------------------------------------------------------
          HEADER SECTION
      ----------------------------------------------------------- */}
      <header
        style={{
          backgroundImage: "url('/images/bg-hd-DSB5yHpM.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="h-[50px] md:h-[60px] flex items-center justify-between px-2 md:px-4 border-b-2 border-[#c49a50] text-gray-800 relative z-50"
      >
        <div className="flex items-center gap-2 md:gap-4">
          <div className="h-6 md:h-8">
            <img
              src="/images/logo-AWC-CUc0ZF3S.webp"
              alt="Logo"
              className="h-full w-auto object-contain"
            />
          </div>
        </div>

        <div className="flex items-center gap-2 md:gap-6 text-xs md:text-sm font-bold text-[#5a4835]">
          <div className="flex items-center gap-1 md:gap-2">
            <img
              src="/images/download(3).webp"
              alt="User"
              className="w-4 h-4 md:w-5 md:h-5 object-contain"
            />
            <span className="hidden sm:inline">001userteam</span>
          </div>

          <div className="flex items-center gap-1 md:gap-2">
            <img
              src="/images/download(2).webp"
              alt="Coin"
              className="w-4 h-4 md:w-5 md:h-5 object-contain"
            />
            <span className="min-w-[60px] md:min-w-[80px]">
              {showBalance ? "9,999,999" : "***********"}
            </span>
            <div
              onClick={() => setShowBalance(!showBalance)}
              className="w-4 h-4 md:w-5 md:h-5 cursor-pointer hover:opacity-80"
            >
              <img
                src={
                  showBalance
                    ? "/images/download(4).webp"
                    : "/images/download(1).webp"
                }
                alt="Show/Hide"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="cursor-pointer w-5 h-5 md:w-6 md:h-6">
          <img
            src="/images/download(5).webp"
            alt="History"
            className="w-full h-full object-contain"
          />
        </div>
      </header>

      {/* -----------------------------------------------------------
          MAIN NAVIGATION
      ----------------------------------------------------------- */}
      <nav className="h-[45px] md:h-[50px] bg-gradient-to-b from-[#4a3b2a] to-[#2b2218] border-b border-[#c49a50] relative z-40">
        <div className="w-full md:w-[80%] max-w-[1600px] mx-auto h-full flex overflow-x-auto scrollbar-hide">
          {["Recent", "Favorite", "Rankings", "Games", "Platform"].map(
            (item, index) => {
              const icons = [
                "fa-file-invoice",
                "fa-star",
                "fa-trophy",
                "fa-border-all",
                "fa-list",
              ];
              const isActive = activeTab === item;

              return (
                <div
                  key={item}
                  onClick={() => setActiveTab(item)}
                  style={
                    isActive
                      ? {
                          backgroundImage: "url('/images/download.webp')",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }
                      : {}
                  }
                  className={`
                  h-full px-4 md:px-6 flex items-center gap-2 cursor-pointer text-xs md:text-sm border-r border-[#5a4835] transition-all duration-300 whitespace-nowrap
                  ${
                    isActive
                      ? "text-[#ffcd79] font-bold"
                      : "text-white hover:bg-white/10"
                  }
                `}
                >
                  <i className={`fa-solid ${icons[index]}`}></i>
                  {item}
                </div>
              );
            },
          )}
        </div>
      </nav>

      {/* -----------------------------------------------------------
          CONTENT AREA
      ----------------------------------------------------------- */}

      {activeTab === "Games" ? (
        // **********************************************************
        // VIEW 1: GAMES TAB (WITH NEW BANNER)
        // **********************************************************
        <div className="bg-[#3e080f] min-h-screen pb-20">
          {/* A. Sub-Navigation */}
          <div className="bg-gradient-to-b from-[#46311d] to-[#24180e] border-b border-[#634f3a] py-2 relative z-40">
            <div className="w-full md:w-[80%] max-w-[1600px] mx-auto flex items-center gap-3 overflow-x-auto px-4 scrollbar-hide">
              {gameCategories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => setGameSubTab(cat.name)}
                  className={`
                     flex items-center gap-2 px-5 py-1.5 rounded-md text-sm whitespace-nowrap border transition-all
                     ${
                       gameSubTab === cat.name
                         ? "bg-gradient-to-b from-[#fceeb5] to-[#c49a50] text-[#3e1e05] border-[#fceeb5] font-bold shadow-[0_0_10px_#c49a50]"
                         : "bg-transparent text-[#c49a50] border-transparent hover:text-[#fceeb5] hover:bg-white/5"
                     }
                   `}
                >
                  <i className={`fa-solid ${cat.icon}`}></i>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>

          {/* B. NEW HERO BANNER SECTION */}
          {/* Note: I've added 'h-[350px] md:h-[450px]' to the container so elements fit vertically */}
          <div className="skycasino-games-bg relative w-full h-[350px] md:h-[250px] overflow-hidden mb-[-50px] md:mb-[-80px]">
            <div className="absolute w-full h-full max-w-7xl overflow-hidden lg:overflow-visible left-1/2 -translate-x-1/2">
              {/* Title */}
              <div className="absolute w-36 left-4 top-4 lg:w-52 lg:top-16 z-20">
                <img
                  src="/casinoimages/img-hot-title-BUxDWY6s.webp"
                  alt="Hot Title"
                />
              </div>

              {/* Character 05 (Top Right) */}
              <div className="absolute w-40 right-12 top-2 opacity-0 plus:right-14 lg:w-48 lg:top-14 lg:right-36 animate-fadeIn-left animate-delay-750 z-20">
                <img
                  src="/casinoimages/img-character05-sDbRPrLU.webp"
                  alt="Char 05"
                />
              </div>

              {/* Coin Pile 02 (Left Bottom) */}
              <div className="absolute w-[135%] -left-28 bottom-0 lg:w-full lg:top-20 lg:-mt-2 z-10">
                <img
                  src="/casinoimages/img-coinpile02-Bxsxip_M.webp"
                  alt="Coins"
                />
              </div>

              {/* Character 06 */}
              <div className="absolute w-28 right-4 top-20 opacity-0 lg:w-28 lg:right-28 lg:top-36 animate-fadeIn-left animate-delay-500 z-20">
                <img
                  src="/casinoimages/img-character06-CkWVg3ab.webp"
                  alt="Char 06"
                />
              </div>

              {/* Character 03 */}
              <div className="absolute w-28 opacity-0 lg:w-32 left-16 lg:left-48 top-8 lg:top-16 animate-fadeIn-right animate-delay-750 z-20">
                <img
                  src="/casinoimages/img-character03-aT9FiV9I.webp"
                  alt="Char 03"
                />
              </div>

              {/* Character 04 */}
              <div className="absolute w-28 left-6 top-32 opacity-0 lg:w-32 lg:top-40 animate-fadeIn-right animate-delay-500 z-20">
                <img
                  src="/casinoimages/img-character04-C8TG7dOZ.webp"
                  alt="Char 04"
                />
              </div>

              {/* Character 02 */}
              <div className="absolute w-24 right-16 mr-2 bottom-0 opacity-0 plus:right-20 lg:w-28 lg:right-72 lg:top-36 animate-fadeIn-left animate-delay-250 z-20">
                <img
                  src="/casinoimages/img-character02-C-XMo1tE.webp"
                  alt="Char 02"
                />
              </div>

              {/* Character 01 (Main) */}
              <div className="absolute w-44 left-24 top-12 plus:w-48 lg:w-56 lg:left-64 lg:top-16 lg:z-30 animate-fadeIn z-30">
                <img
                  src="/casinoimages/img-character01-DGvqWRvb.webp"
                  alt="Char 01"
                />
              </div>

              {/* Coin Pile 01 */}
              <div className="absolute w-full -left-10 bottom-0 lg:w-9/12 lg:top-48 lg:left-16 lg:-mt-0.5 z-0">
                <img
                  src="/casinoimages/img-coinpile01-DtXeB_TF.webp"
                  alt="Coins 01"
                />
              </div>
            </div>
          </div>

          {/* --- GAME GRID --- */}
          <div className="w-full md:w-[80%] max-w-[1600px] mx-auto relative z-30 px-4 mt-10 md:mt-16">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
              {hotGames.map((game) => {
                // Get the specific assets (color & icon) for this provider
                const assets = getProviderAssets(game.provider);

                return (
                  <div
                    key={game.id}
                    className="flex flex-col items-center group cursor-pointer"
                    onClick={() => handleGameClick(game)} // CLICK HANDLER ADDED
                  >
                    {/* --- CARD CONTAINER --- */}
                    <div className="relative mb-3 w-full">
                      {/* 1. HOT TAG (Z-30: Overlaps everything) */}
                      <div className="absolute -top-1 -left-1 z-30">
                        <img
                          src="/casinoimages/download.webp"
                          alt="HOT"
                          className="w-12 md:w-16 object-contain drop-shadow-md"
                        />
                      </div>

                      {/* 2. DYNAMIC HEADER BAR */}
                      {/* Z-20: Sits on top of the card image */}
                      <div className="absolute -top-[20px] left-0 w-[96%] h-[20px] z-20 pointer-events-none">
                        {/* Background Shape with Diagonal Cut */}
                        <div
                          className={`w-full h-full ${assets.bg} shadow-sm`}
                          style={{
                            clipPath:
                              "polygon(20px 0, 100% 0, 100% 100%, 0% 100%)",
                          }}
                        ></div>

                        {/* Header Content */}
                        <div className="absolute inset-0 flex justify-between items-center px-2 pl-7">
                          {/* Separate Clip Art Icon */}
                          <div className="text-white opacity-90 flex-none w-4 h-4 md:w-5 md:h-5">
                            {assets.icon}
                          </div>

                          {/* Provider Name */}
                          <span className="text-white text-[10px] md:text-[11px] font-normal uppercase tracking-wider font-sans drop-shadow-sm truncate ml-1">
                            {game.provider}
                          </span>
                        </div>
                      </div>

                      {/* 3. GAME IMAGE */}
                      <img
                        className="absolute top-0 left-0 w-full h-full object-contain p-2 z-10 "
                        src={game.img}
                        onError={(e) => (e.target.src = "/img-default.png")}
                        alt={game.title}
                      />

                      {/* 4. STAR / FAVORITE BUTTON */}
                      <div className="absolute z-20 -bottom-2 right-1 w-10 h-10 flex items-center justify-center">
                        <img
                          src="/casinoimages/games/download(1).webp"
                          alt="Star Default"
                          className="w-full h-full object-contain drop-shadow-md block group-hover:hidden transition-all duration-300"
                        />
                        <img
                          src="/casinoimages/games/download(2).webp"
                          alt="Star Active"
                          className="w-full h-full object-contain drop-shadow-md hidden group-hover:block transition-all duration-300"
                        />
                      </div>

                      {/* 5. BACKGROUND FRAME */}
                      <div
                        className="pt-[100%] bg-contain bg-center bg-no-repeat rounded-md overflow-hidden"
                        style={{
                          backgroundImage:
                            "url('/casinoimages/img-silver-Bl8yRsWY.webp')",
                        }}
                      ></div>
                    </div>

                    {/* Title Below Card */}
                    <div className="mt-2 text-[#fceeb5] text-xs md:text-sm font-bold tracking-wide text-center uppercase group-hover:text-white transition-colors">
                      {game.title}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        // **********************************************************
        // VIEW 2: PLATFORM TAB (ORIGINAL LAYOUT)
        // **********************************************************
        <main className="w-[95%] md:w-[80%] max-w-[1600px] mx-auto py-5">
          <div className="mb-6 p-3 md:p-4 bg-gradient-to-r from-[#6d5840] to-[#4a3b2a] border border-[#8b6b36] flex flex-col md:flex-row justify-between items-center gap-3">
            <h2 className="text-base md:text-lg font-semibold text-gray-200 w-full md:w-auto text-center md:text-left">
              Platform List
            </h2>

            <div className="flex flex-col md:flex-row items-center gap-3 w-full md:w-auto">
              <div className="flex w-full justify-between gap-3">
                <div className="flex items-center gap-2">
                  <div
                    onClick={() => setViewMode("list")}
                    className={`cursor-pointer p-1.5 rounded ${viewMode === "list" ? "bg-[#8b6b36] text-white" : "text-[#d4af64]"}`}
                  >
                    <i className="fa-solid fa-list-ul text-lg md:text-xl"></i>
                  </div>
                  <div
                    onClick={() => setViewMode("grid")}
                    className={`cursor-pointer p-1.5 rounded ${viewMode === "grid" ? "bg-[#8b6b36] text-white" : "text-[#d4af64]"}`}
                  >
                    <i className="fa-solid fa-border-all text-lg md:text-xl"></i>
                  </div>
                </div>

                <div className="relative flex-grow md:flex-grow-0">
                  <input
                    type="text"
                    placeholder="Search"
                    className="w-full md:w-64 pl-4 pr-4 py-1.5 md:py-2 rounded-full border-none outline-none text-gray-700 text-sm focus:ring-2 focus:ring-[#c49a50]"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${viewMode === "grid" ? "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4" : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5"} pb-10`}
          >
            {games.map((game) => (
              <div
                key={game.id}
                style={{
                  backgroundImage: "url('/images/bg-platform-Ve3IkFID.jpg')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                className="group relative rounded-lg overflow-hidden shadow-lg hover:shadow-[0_0_10px_#c49a50] transition-all cursor-pointer"
                onClick={() => handleGameClick(game)}
              >
                {/* --- CIRCULAR LOADER OVERLAY --- */}
                {/* {launchingId === game.id && (
                  <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-black/80 backdrop-blur-sm">
                    <div className="relative w-16 h-16">
                      Background Circle
                      <svg className="w-full h-full transform -rotate-90">
                        <circle
                          cx="32"
                          cy="32"
                          r="28"
                          stroke="currentColor"
                          strokeWidth="4"
                          fill="transparent"
                          className="text-gray-700"
                        />
                        Progress Circle
                        <circle
                          cx="32"
                          cy="32"
                          r="28"
                          stroke="currentColor"
                          strokeWidth="4"
                          fill="transparent"
                          strokeDasharray={175.9}
                          strokeDashoffset={
                            175.9 - (175.9 * loadProgress) / 100
                          }
                          strokeLinecap="round"
                          className="text-[#c49a50] transition-all duration-300 ease-out"
                        />
                      </svg>
                      <span className="absolute inset-0 flex items-center justify-center text-[10px] font-bold text-white">
                        {loadProgress}%
                      </span>
                    </div>
                    <span className="mt-2 text-[10px] uppercase tracking-tighter text-[#fceeb5] animate-pulse">
                      Launching...
                    </span>
                  </div>
                )} */}

                {viewMode === "grid" ? (
                  <>
                    <div className="relative h-[120px] md:h-[160px] w-full">
                      <img
                        src={game.gridImage}
                        alt={game.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 w-full h-[30px] md:h-[40px] bg-black/60 flex items-center justify-between px-2">
                        <div className="flex gap-1 md:gap-2 text-white/70 text-[10px] md:text-[12px]">
                          <i className="fa-solid fa-layer-group"></i>
                          <i className="fa-solid fa-gamepad"></i>
                        </div>
                        <button
                          className={`px-2 py-0.5 md:px-3 md:py-1 rounded-full text-[8px] md:text-[10px] font-bold uppercase shadow-md ${game.btnType === "play" ? "bg-gradient-to-b from-[#005c3e] to-[#003322] border border-[#00ffaa] text-white" : "bg-gradient-to-b from-[#8b6b36] to-[#4a3b2a] border border-[#c49a50] text-[#fceeb5]"}`}
                        >
                          {game.btnType === "play" ? "Play Now" : "View More"}
                        </button>
                      </div>
                    </div>
                    <div className="bg-[#141414] py-1.5 md:py-2 flex items-center justify-center border-t border-white/5">
                      <h3 className="text-[#fceeb5] text-[10px] md:text-xs font-bold uppercase tracking-wider">
                        {game.title}
                      </h3>
                    </div>
                  </>
                ) : (
                  <div className="relative h-[90px] md:h-[100px] border border-[#5a4835] p-3 md:p-4 flex items-center shadow-lg">
                    <div className="absolute top-2 right-2 text-[10px] md:text-xs text-gray-500">
                      <i className={`fa-solid ${game.cornerIcon}`}></i>
                    </div>
                    <div className="relative z-10 flex items-center w-full">
                      <div className="w-[60px] h-[60px] md:w-[70px] md:h-[70px] rounded-full border-2 bg-black flex items-center justify-center mr-3 md:mr-4 shrink-0 overflow-hidden border-yellow-600">
                        <img
                          src={game.listImage}
                          alt={game.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-[#fceeb5] text-sm md:text-base font-bold uppercase tracking-wide">
                          {game.title}
                        </h3>
                        <button
                          className={`float-right px-3 py-1 md:px-4 md:py-1.5 rounded-full mt-1 text-[9px] md:text-[10px] font-bold uppercase shadow transition-all ${game.btnType === "play" ? "bg-gradient-to-b from-[#005c3e] to-[#003322] border border-[#00ffaa] text-white" : "bg-transparent border border-[#c49a50] text-[#c49a50]"}`}
                        >
                          {game.btnType === "play" ? "Play Now" : "View More"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </main>
      )}
    </div>
  );
};

export default Skylivecasino;
